var r=16;export{r as CHILDREN_SHIFT_DISTANCE};
